/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedVerificationsIndexRouteImport } from './routes/_authenticated/verifications/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSeafarersIndexRouteImport } from './routes/_authenticated/seafarers/index'
import { Route as AuthenticatedReviewsIndexRouteImport } from './routes/_authenticated/reviews/index'
import { Route as AuthenticatedRanksIndexRouteImport } from './routes/_authenticated/ranks/index'
import { Route as AuthenticatedJobsIndexRouteImport } from './routes/_authenticated/jobs/index'
import { Route as AuthenticatedCompaniesIndexRouteImport } from './routes/_authenticated/companies/index'
import { Route as AuthenticatedCertificatesIndexRouteImport } from './routes/_authenticated/certificates/index'
import { Route as AuthenticatedApplicationsIndexRouteImport } from './routes/_authenticated/applications/index'
import { Route as AuthenticatedUsersIdIndexRouteImport } from './routes/_authenticated/users/$id/index'
import { Route as AuthenticatedSeafarersIdIndexRouteImport } from './routes/_authenticated/seafarers/$id/index'
import { Route as AuthenticatedJobsIdIndexRouteImport } from './routes/_authenticated/jobs/$id/index'
import { Route as AuthenticatedCompaniesIdIndexRouteImport } from './routes/_authenticated/companies/$id/index'
import { Route as AuthenticatedUsersIdEditRouteImport } from './routes/_authenticated/users/$id/edit'
import { Route as AuthenticatedSeafarersIdEditRouteImport } from './routes/_authenticated/seafarers/$id/edit'
import { Route as AuthenticatedJobsIdEditRouteImport } from './routes/_authenticated/jobs/$id/edit'
import { Route as AuthenticatedCompaniesIdEditRouteImport } from './routes/_authenticated/companies/$id/edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedVerificationsIndexRoute =
  AuthenticatedVerificationsIndexRouteImport.update({
    id: '/verifications/',
    path: '/verifications/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSeafarersIndexRoute =
  AuthenticatedSeafarersIndexRouteImport.update({
    id: '/seafarers/',
    path: '/seafarers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReviewsIndexRoute =
  AuthenticatedReviewsIndexRouteImport.update({
    id: '/reviews/',
    path: '/reviews/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRanksIndexRoute = AuthenticatedRanksIndexRouteImport.update({
  id: '/ranks/',
  path: '/ranks/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedJobsIndexRoute = AuthenticatedJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCertificatesIndexRoute =
  AuthenticatedCertificatesIndexRouteImport.update({
    id: '/certificates/',
    path: '/certificates/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApplicationsIndexRoute =
  AuthenticatedApplicationsIndexRouteImport.update({
    id: '/applications/',
    path: '/applications/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersIdIndexRoute =
  AuthenticatedUsersIdIndexRouteImport.update({
    id: '/users/$id/',
    path: '/users/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSeafarersIdIndexRoute =
  AuthenticatedSeafarersIdIndexRouteImport.update({
    id: '/seafarers/$id/',
    path: '/seafarers/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsIdIndexRoute =
  AuthenticatedJobsIdIndexRouteImport.update({
    id: '/jobs/$id/',
    path: '/jobs/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesIdIndexRoute =
  AuthenticatedCompaniesIdIndexRouteImport.update({
    id: '/companies/$id/',
    path: '/companies/$id/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersIdEditRoute =
  AuthenticatedUsersIdEditRouteImport.update({
    id: '/users/$id/edit',
    path: '/users/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSeafarersIdEditRoute =
  AuthenticatedSeafarersIdEditRouteImport.update({
    id: '/seafarers/$id/edit',
    path: '/seafarers/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsIdEditRoute = AuthenticatedJobsIdEditRouteImport.update({
  id: '/jobs/$id/edit',
  path: '/jobs/$id/edit',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCompaniesIdEditRoute =
  AuthenticatedCompaniesIdEditRouteImport.update({
    id: '/companies/$id/edit',
    path: '/companies/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/applications/': typeof AuthenticatedApplicationsIndexRoute
  '/certificates/': typeof AuthenticatedCertificatesIndexRoute
  '/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/jobs/': typeof AuthenticatedJobsIndexRoute
  '/ranks/': typeof AuthenticatedRanksIndexRoute
  '/reviews/': typeof AuthenticatedReviewsIndexRoute
  '/seafarers/': typeof AuthenticatedSeafarersIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/verifications/': typeof AuthenticatedVerificationsIndexRoute
  '/companies/$id/edit': typeof AuthenticatedCompaniesIdEditRoute
  '/jobs/$id/edit': typeof AuthenticatedJobsIdEditRoute
  '/seafarers/$id/edit': typeof AuthenticatedSeafarersIdEditRoute
  '/users/$id/edit': typeof AuthenticatedUsersIdEditRoute
  '/companies/$id/': typeof AuthenticatedCompaniesIdIndexRoute
  '/jobs/$id/': typeof AuthenticatedJobsIdIndexRoute
  '/seafarers/$id/': typeof AuthenticatedSeafarersIdIndexRoute
  '/users/$id/': typeof AuthenticatedUsersIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AuthenticatedIndexRoute
  '/applications': typeof AuthenticatedApplicationsIndexRoute
  '/certificates': typeof AuthenticatedCertificatesIndexRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/jobs': typeof AuthenticatedJobsIndexRoute
  '/ranks': typeof AuthenticatedRanksIndexRoute
  '/reviews': typeof AuthenticatedReviewsIndexRoute
  '/seafarers': typeof AuthenticatedSeafarersIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/verifications': typeof AuthenticatedVerificationsIndexRoute
  '/companies/$id/edit': typeof AuthenticatedCompaniesIdEditRoute
  '/jobs/$id/edit': typeof AuthenticatedJobsIdEditRoute
  '/seafarers/$id/edit': typeof AuthenticatedSeafarersIdEditRoute
  '/users/$id/edit': typeof AuthenticatedUsersIdEditRoute
  '/companies/$id': typeof AuthenticatedCompaniesIdIndexRoute
  '/jobs/$id': typeof AuthenticatedJobsIdIndexRoute
  '/seafarers/$id': typeof AuthenticatedSeafarersIdIndexRoute
  '/users/$id': typeof AuthenticatedUsersIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/applications/': typeof AuthenticatedApplicationsIndexRoute
  '/_authenticated/certificates/': typeof AuthenticatedCertificatesIndexRoute
  '/_authenticated/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/_authenticated/jobs/': typeof AuthenticatedJobsIndexRoute
  '/_authenticated/ranks/': typeof AuthenticatedRanksIndexRoute
  '/_authenticated/reviews/': typeof AuthenticatedReviewsIndexRoute
  '/_authenticated/seafarers/': typeof AuthenticatedSeafarersIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/verifications/': typeof AuthenticatedVerificationsIndexRoute
  '/_authenticated/companies/$id/edit': typeof AuthenticatedCompaniesIdEditRoute
  '/_authenticated/jobs/$id/edit': typeof AuthenticatedJobsIdEditRoute
  '/_authenticated/seafarers/$id/edit': typeof AuthenticatedSeafarersIdEditRoute
  '/_authenticated/users/$id/edit': typeof AuthenticatedUsersIdEditRoute
  '/_authenticated/companies/$id/': typeof AuthenticatedCompaniesIdIndexRoute
  '/_authenticated/jobs/$id/': typeof AuthenticatedJobsIdIndexRoute
  '/_authenticated/seafarers/$id/': typeof AuthenticatedSeafarersIdIndexRoute
  '/_authenticated/users/$id/': typeof AuthenticatedUsersIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/applications/'
    | '/certificates/'
    | '/companies/'
    | '/jobs/'
    | '/ranks/'
    | '/reviews/'
    | '/seafarers/'
    | '/settings/'
    | '/users/'
    | '/verifications/'
    | '/companies/$id/edit'
    | '/jobs/$id/edit'
    | '/seafarers/$id/edit'
    | '/users/$id/edit'
    | '/companies/$id/'
    | '/jobs/$id/'
    | '/seafarers/$id/'
    | '/users/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/applications'
    | '/certificates'
    | '/companies'
    | '/jobs'
    | '/ranks'
    | '/reviews'
    | '/seafarers'
    | '/settings'
    | '/users'
    | '/verifications'
    | '/companies/$id/edit'
    | '/jobs/$id/edit'
    | '/seafarers/$id/edit'
    | '/users/$id/edit'
    | '/companies/$id'
    | '/jobs/$id'
    | '/seafarers/$id'
    | '/users/$id'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/'
    | '/_authenticated/applications/'
    | '/_authenticated/certificates/'
    | '/_authenticated/companies/'
    | '/_authenticated/jobs/'
    | '/_authenticated/ranks/'
    | '/_authenticated/reviews/'
    | '/_authenticated/seafarers/'
    | '/_authenticated/settings/'
    | '/_authenticated/users/'
    | '/_authenticated/verifications/'
    | '/_authenticated/companies/$id/edit'
    | '/_authenticated/jobs/$id/edit'
    | '/_authenticated/seafarers/$id/edit'
    | '/_authenticated/users/$id/edit'
    | '/_authenticated/companies/$id/'
    | '/_authenticated/jobs/$id/'
    | '/_authenticated/seafarers/$id/'
    | '/_authenticated/users/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/verifications/': {
      id: '/_authenticated/verifications/'
      path: '/verifications'
      fullPath: '/verifications/'
      preLoaderRoute: typeof AuthenticatedVerificationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/seafarers/': {
      id: '/_authenticated/seafarers/'
      path: '/seafarers'
      fullPath: '/seafarers/'
      preLoaderRoute: typeof AuthenticatedSeafarersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reviews/': {
      id: '/_authenticated/reviews/'
      path: '/reviews'
      fullPath: '/reviews/'
      preLoaderRoute: typeof AuthenticatedReviewsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ranks/': {
      id: '/_authenticated/ranks/'
      path: '/ranks'
      fullPath: '/ranks/'
      preLoaderRoute: typeof AuthenticatedRanksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs/': {
      id: '/_authenticated/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof AuthenticatedJobsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/': {
      id: '/_authenticated/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthenticatedCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/certificates/': {
      id: '/_authenticated/certificates/'
      path: '/certificates'
      fullPath: '/certificates/'
      preLoaderRoute: typeof AuthenticatedCertificatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/applications/': {
      id: '/_authenticated/applications/'
      path: '/applications'
      fullPath: '/applications/'
      preLoaderRoute: typeof AuthenticatedApplicationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/$id/': {
      id: '/_authenticated/users/$id/'
      path: '/users/$id'
      fullPath: '/users/$id/'
      preLoaderRoute: typeof AuthenticatedUsersIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/seafarers/$id/': {
      id: '/_authenticated/seafarers/$id/'
      path: '/seafarers/$id'
      fullPath: '/seafarers/$id/'
      preLoaderRoute: typeof AuthenticatedSeafarersIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs/$id/': {
      id: '/_authenticated/jobs/$id/'
      path: '/jobs/$id'
      fullPath: '/jobs/$id/'
      preLoaderRoute: typeof AuthenticatedJobsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/$id/': {
      id: '/_authenticated/companies/$id/'
      path: '/companies/$id'
      fullPath: '/companies/$id/'
      preLoaderRoute: typeof AuthenticatedCompaniesIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/$id/edit': {
      id: '/_authenticated/users/$id/edit'
      path: '/users/$id/edit'
      fullPath: '/users/$id/edit'
      preLoaderRoute: typeof AuthenticatedUsersIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/seafarers/$id/edit': {
      id: '/_authenticated/seafarers/$id/edit'
      path: '/seafarers/$id/edit'
      fullPath: '/seafarers/$id/edit'
      preLoaderRoute: typeof AuthenticatedSeafarersIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs/$id/edit': {
      id: '/_authenticated/jobs/$id/edit'
      path: '/jobs/$id/edit'
      fullPath: '/jobs/$id/edit'
      preLoaderRoute: typeof AuthenticatedJobsIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/$id/edit': {
      id: '/_authenticated/companies/$id/edit'
      path: '/companies/$id/edit'
      fullPath: '/companies/$id/edit'
      preLoaderRoute: typeof AuthenticatedCompaniesIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedApplicationsIndexRoute: typeof AuthenticatedApplicationsIndexRoute
  AuthenticatedCertificatesIndexRoute: typeof AuthenticatedCertificatesIndexRoute
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
  AuthenticatedJobsIndexRoute: typeof AuthenticatedJobsIndexRoute
  AuthenticatedRanksIndexRoute: typeof AuthenticatedRanksIndexRoute
  AuthenticatedReviewsIndexRoute: typeof AuthenticatedReviewsIndexRoute
  AuthenticatedSeafarersIndexRoute: typeof AuthenticatedSeafarersIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedVerificationsIndexRoute: typeof AuthenticatedVerificationsIndexRoute
  AuthenticatedCompaniesIdEditRoute: typeof AuthenticatedCompaniesIdEditRoute
  AuthenticatedJobsIdEditRoute: typeof AuthenticatedJobsIdEditRoute
  AuthenticatedSeafarersIdEditRoute: typeof AuthenticatedSeafarersIdEditRoute
  AuthenticatedUsersIdEditRoute: typeof AuthenticatedUsersIdEditRoute
  AuthenticatedCompaniesIdIndexRoute: typeof AuthenticatedCompaniesIdIndexRoute
  AuthenticatedJobsIdIndexRoute: typeof AuthenticatedJobsIdIndexRoute
  AuthenticatedSeafarersIdIndexRoute: typeof AuthenticatedSeafarersIdIndexRoute
  AuthenticatedUsersIdIndexRoute: typeof AuthenticatedUsersIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedApplicationsIndexRoute: AuthenticatedApplicationsIndexRoute,
  AuthenticatedCertificatesIndexRoute: AuthenticatedCertificatesIndexRoute,
  AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  AuthenticatedJobsIndexRoute: AuthenticatedJobsIndexRoute,
  AuthenticatedRanksIndexRoute: AuthenticatedRanksIndexRoute,
  AuthenticatedReviewsIndexRoute: AuthenticatedReviewsIndexRoute,
  AuthenticatedSeafarersIndexRoute: AuthenticatedSeafarersIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedVerificationsIndexRoute: AuthenticatedVerificationsIndexRoute,
  AuthenticatedCompaniesIdEditRoute: AuthenticatedCompaniesIdEditRoute,
  AuthenticatedJobsIdEditRoute: AuthenticatedJobsIdEditRoute,
  AuthenticatedSeafarersIdEditRoute: AuthenticatedSeafarersIdEditRoute,
  AuthenticatedUsersIdEditRoute: AuthenticatedUsersIdEditRoute,
  AuthenticatedCompaniesIdIndexRoute: AuthenticatedCompaniesIdIndexRoute,
  AuthenticatedJobsIdIndexRoute: AuthenticatedJobsIdIndexRoute,
  AuthenticatedSeafarersIdIndexRoute: AuthenticatedSeafarersIdIndexRoute,
  AuthenticatedUsersIdIndexRoute: AuthenticatedUsersIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
